






















































import { Component, Vue, Prop, Ref, Watch } from "vue-property-decorator";
import { DateTime } from "luxon";
import TimeTrackDayTrack from "./TimeTrackDayTrack.vue";
import DateField from "@/components/misc/DateField.vue";
import { Getter } from "vuex-class";
import * as _ from "lodash";

type TimeTrackMonth = {
  from: DateTime;
  to: DateTime;
};

@Component({ components: { TimeTrackDayTrack, DateField } })
export default class BoxTimeTrack extends Vue {
  @Prop({ required: true }) start?: DateTime;
  @Prop({ required: true }) end?: DateTime;
  @Prop({ default: 48 }) dayW?: number;
  @Prop() current?: DateTime;
  @Prop({ default: false }) dragging?: boolean;
  @Prop({ default: false }) isMobile?: boolean;
  @Prop({ default: false }) isContingent?: boolean;

  @Getter("language/language") language?: string;

  menu = false;

  currentISO = DateTime.local()
    .toISODate()
    ?.substring(0, 7);
  @Watch("current", { immediate: true })
  currentChanged(fresh?: DateTime) {
    this.currentISO = fresh?.toISODate() ?? new Date().toJSON().substring(0, 7);
  }

  @Getter("showMenu") navMenu?: boolean;
  @Getter("drawerCollapsed") navMenuCollapsed?: boolean;

  @Watch("dayW")
  dayWWatch() {
    setTimeout(() => {
      this.calculateWidths();
    }, 250);
  }

  @Watch("dragging")
  draggingWatch(fresh: boolean, old: boolean) {
    if (fresh && !old) {
      this.interval = setInterval(() => {
        this.calculateWidths();
      }, 250);
    } else {
      clearInterval(this.interval);
      this.calculateWidths();
    }
  }

  widths = {} as any;
  interval: any;
  timeout: any;

  calculateWidths() {
    const refs = this.months.map(
      (x) => x.from.year.toString() + x.from.month.toString()
    );

    let offset = 296;
    if (this.navMenu && !this.navMenuCollapsed) {
      offset = 496;
    } else if (!this.navMenu) {
      offset = 240;
    }

    const temp = {} as any;
    for (const x of refs) {
      const el = this.$refs[x] as Element[];
      if (el.length > 0) {
        const left = el[0].getBoundingClientRect().left;
        const width = el[0].getBoundingClientRect().width - 150;

        temp[x] = Math.min(width - 2, Math.abs(Math.min(0, left - offset)));
      }
    }

    if (!_.isEqual(temp, this.widths)) {
      this.widths = temp;
    }
  }

  getStyle(ref: string) {
    const width = this.widths[ref];
    if (width != undefined) {
      return `width: ${width}px;`;
    }

    return "";
  }

  mounted() {
    this.timeout = setTimeout(() => {
      this.calculateWidths();
    }, 1000);
  }

  destroyed() {
    clearInterval(this.interval);
    clearTimeout(this.timeout);
  }

  get months(): TimeTrackMonth[] {
    if (!this.start || !this.end) return [];

    const start = this.start;
    const end = this.end;

    const months = (end.year - start.year) * 12 + end.month - start.month + 1;

    return Array.from(Array(months), (_, i) => {
      return {
        from: i === 0 ? start : start.plus({ months: i }).startOf("month"),
        to: i === months - 1 ? end : start.plus({ months: i }).endOf("month"),
      };
    });
  }

  get emptySlots() {
    if(this.start && this.end && (!this.isContingent || this.end?.diff(this.start, "days").days <= 7)) {
      return 0;
    }
    
    return 31 - this.months[0].to.diff(this.months[0].from, "days").days;
  }

  /* Vuetify has a bug where it retains focus, :retain-focus-on-click="false" doesn't fix it 
  https://github.com/vuetifyjs/vuetify/issues/3125#issuecomment-527843283 */
  @Ref("navRightBtn") navRightBtn?: Vue;
  navRight() {
    if (this.navRightBtn?.$el instanceof HTMLElement) {
      this.navRightBtn?.$el.blur();
    }
    this.$emit("nav-right");
  }
  @Ref("navLeftBtn") navLeftBtn?: Vue;
  navLeft() {
    if (this.navLeftBtn?.$el instanceof HTMLElement) {
      this.navLeftBtn?.$el.blur();
    }
    this.$emit("nav-left");
  }
}
